import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie, X } from "lucide-react";

const KEY = "gj_cookie_consent";

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setShow(true);
    } catch (e) {
      setShow(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(KEY, JSON.stringify({ accepted: true, at: Date.now() }));
    } catch (e) {
      if (process.env.NODE_ENV !== "production") console.debug("Cookie consent persist failed:", e);
    }
    setShow(false);
  };

  const dismiss = () => setShow(false);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="cookie-consent"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ type: "spring", stiffness: 260, damping: 26 }}
          className="fixed left-3 sm:left-6 bottom-20 md:bottom-6 z-[60] w-[calc(100%-1.5rem)] sm:w-auto max-w-md"
        >
          <div className="relative rounded-2xl border border-border bg-card/95 backdrop-blur-xl shadow-2xl p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-4">
            <div className="flex items-start gap-3 flex-1">
              <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center shrink-0">
                <Cookie className="w-5 h-5 text-primary" />
              </div>
              <p className="text-sm text-muted-foreground leading-relaxed">
                Usamos cookies para melhorar sua experiência e analisar o uso do site. Ao continuar, você concorda com nossa{" "}
                <Link data-testid="cookie-policy-link" to="/cookies" className="text-primary font-semibold underline underline-offset-2">
                  Política de Cookies
                </Link>.
              </p>
            </div>
            <div className="flex items-center gap-2 shrink-0">
              <button
                data-testid="cookie-accept"
                onClick={accept}
                className="px-5 py-2.5 rounded-full bg-brand-gradient text-white font-semibold text-sm press whitespace-nowrap"
              >
                Aceitar
              </button>
              <button
                data-testid="cookie-dismiss"
                onClick={dismiss}
                aria-label="Fechar"
                className="p-2 rounded-full text-muted-foreground hover:bg-muted"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
